import styles from "./styles.module.scss";
import { ReactComponent as OutlineCheckSmall } from "assets/svg/outline-check-small.svg";
import { useEffect, useState } from "react";

type Props = {
  onHide?: () => void;
  /**
   * duration for the moved tag to show
   * @default 2000
   */
  duration?: number;
  success?: boolean;
  message?: string;
};
const MovedMessageTag = ({
  onHide,
  duration,
  success = false,
  message = "",
}: Props) => {
  const [localShow, setLocalShow] = useState(!!message);

  useEffect(() => setLocalShow(!!message), [message]);

  useEffect(() => {
    if (!localShow) {
      return;
    }
    const timer = setTimeout(() => {
      setLocalShow(false);
      onHide && onHide();
    }, duration ?? 2000);

    return () => timer && clearTimeout(timer);
  }, [localShow, onHide, duration]);

  return localShow ? (
    <div className={styles["moved-message-tag"]}>
      <div className={styles["moved-message-tag__content"]}>
        {success && <OutlineCheckSmall className={"mr-2"} />}
        <div>{message}</div>
      </div>
    </div>
  ) : null;
};

export default MovedMessageTag;
